import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  modalBackdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  card: {
    width: 420,
    borderRadius: 16,
    boxShadow: '0 20px 45px rgba(0, 0, 0, 0.2)',
  },
  content: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: 'clamp(8px, 1.30vw, 27px)',
  },
  closeButton: {
    padding: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.primary.gray,
    fontSize: 14,
  },
  amountSummary: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
  },
  owedAmountLabel: {
    fontSize: 'clamp(14px, 0.94vw, 18px)',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  owedAmountValue: {
    fontWeight: 600,
  },
  paidAmountLabel: {
    fontSize: 'clamp(13px, 0.78vw, 16px)',
    fontWeight: 400,
    color: theme.palette.primary.gray,
  },
  paidAmountValue: {
    fontWeight: 400,
  },
  dropzone: {
    position: 'relative',
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 16,
    padding: theme.spacing(4, 3),
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    transition: 'border-color 0.2s ease, background-color 0.2s ease',
    cursor: 'pointer',
  },
  dropzoneActive: {
    borderColor: theme.palette.secondary.main,
    backgroundColor: '#f0f9fc',
  },
  dropzoneIcon: {
    width: 40,
    height: 40,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1.5),
  },
  dropzoneText: {
    fontWeight: 400,
    color: theme.palette.primary.main,
    fontSize: 'clamp(13px, 0.73vw, 15px)',
  },
  dropzoneHelper: {
    marginTop: theme.spacing(1),
    color: theme.palette.primary.gray,
    fontSize: 'clamp(11px, 0.63vw, 13px)',
    lineHeight: 1.4,
  },
  fileName: {
    marginTop: theme.spacing(1.5),
    fontSize: 13,
    color: theme.palette.primary.main,
    wordBreak: 'break-all',
  },
  hiddenInput: {
    display: 'none',
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  cancelButton: {
    flex: 1,
    backgroundColor: theme.palette.primary.red,
    color: theme.palette.primary.white,
    fontSize: 'clamp(12px, 1.04vw, 21px)',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(1.2, 2),
    '&:hover': {
      backgroundColor: '#d53c3a',
    },
  },
  submitButton: {
    flex: 1,
    fontSize: 'clamp(12px, 1.04vw, 21px)',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(1.2, 2),
  },
  inputLabel: {
    fontSize: 'clamp(13px, 0.73vw, 15px)',
    color: theme.palette.primary.gray,
    marginBottom: theme.spacing(0.5),
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      fontSize: 'clamp(13px, 0.73vw, 15px)',
      padding: theme.spacing(1),
    },
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
      padding: 0,
    },
  },
  paymentMethodSelect: {
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 9px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
}));

export default useStyles;
